module.exports = __webpack_public_path__ + "static/img/16.64fe15b6.jpg";